import PreferencesSettings from './PreferencesSettings';

export default PreferencesSettings;
